var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscriptionPlans(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3640_9875)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3640_9875",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.472412,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3640_9875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 6.68294V4.57768C7 3.99873 7.196 3.50294 7.588 3.09031C7.97933 2.67838 8.45 2.47241 9 2.47241H15C15.55 2.47241 16.021 2.67838 16.413 3.09031C16.8043 3.50294 17 3.99873 17 4.57768V6.68294H20C20.55 6.68294 21.021 6.88925 21.413 7.30189C21.8043 7.71382 22 8.20925 22 8.7882V20.3671C22 20.9461 21.8043 21.4419 21.413 21.8545C21.021 22.2664 20.55 22.4724 20 22.4724H4C3.45 22.4724 2.97933 22.2664 2.588 21.8545C2.196 21.4419 2 20.9461 2 20.3671V8.7882C2 8.20925 2.196 7.71382 2.588 7.30189C2.97933 6.88925 3.45 6.68294 4 6.68294H7ZM9 6.68294H15V4.57768H9V6.68294ZM4 18.2619H20V15.104H4V18.2619Z",
    fill: "#6E6E6E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3640_9875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.472412)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionPlans);
export default __webpack_public_path__ + "static/media/subscriptionPlans.01c649e60f68c571f4b7287e4485a1d4.svg";
export { ForwardRef as ReactComponent };